import { Injectable } from '@angular/core';
import { IID_OL_CONTRATTO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IIDolContrattoQuery } from './iidOlContratto.query';
import { IIDolContrattoStore } from './iidOlContratto.store';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.CONTRATTO)
export class IIDolContrattoService extends CrudService<IID_OL_CONTRATTO, IIDolContrattoStore, IIDolContrattoQuery> {
  constructor(
    protected store: IIDolContrattoStore,
    public query: IIDolContrattoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_CONTRATTO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
